import { useState, useEffect } from 'react';
import { Box, makeStyles, Button, Typography } from '@material-ui/core';

const ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.vntech24h.vcarsmobile';
const IOS_URL = 'https://apps.apple.com/vn/app/vgps/id1584121002?l=vi';
const REDIRECT_DELAY = 1500; // ms

const detectDevice = () => {
  const ua = navigator.userAgent || '';
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  return 'desktop';
};

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    background: '#FFFFFF',
    height: '100%',
    backgroundImage: `url('/static/backgroundApp.svg')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  },
  wrapper: {
    maxWidth: 968,
    margin: '0 auto'
  },
  btnDownload: {
    minWidth: '200px',
    background: '#E5E6EB',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    padding: '10px 0px',
    color: '#0C1132',
    fontSize: '14px',
    fontWeight: '600',

    '&:hover': {
      color: '#EE0434'
    }
  },
  redirectNotice: {
    color: '#666',
    fontSize: '13px',
    fontStyle: 'italic',
    textAlign: 'center'
  }
}));

const AppDownload = () => {
  const classes = useStyles();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const device = detectDevice();
    if (device === 'desktop') return;

    setIsRedirecting(true);
    const targetUrl = device === 'android' ? ANDROID_URL : IOS_URL;

    const timer = setTimeout(() => {
      window.location.href = targetUrl;
    }, REDIRECT_DELAY);

    // Cleanup: hủy timeout nếu component unmount trước khi redirect
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box className={classes.root}>
      <Box
        className={classes.wrapper}
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
          paddingBottom: '100px'
        }}
      >
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            alignItems: 'center'
          }}
        >
          {isRedirecting && (
            <Typography className={classes.redirectNotice}>
              Đang kiểm tra thiết bị và chuyển hướng...
            </Typography>
          )}

          <Button className={classes.btnDownload} href={ANDROID_URL}>
            <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Box style={{ width: '22px', height: '25px' }}>
                <img
                  src={'/static/iconSvg/android.svg'}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  alt="Android"
                />
              </Box>
              <span style={{ lineHeight: '25px' }}>Android Download</span>
            </Box>
          </Button>

          <Button className={classes.btnDownload} href={IOS_URL}>
            <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ width: '20px', height: '25px' }}>
                <img
                  src={'/static/iconSvg/apple.svg'}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  alt="iOS"
                />
              </span>
              <span style={{ lineHeight: '25px' }}>IOS Download</span>
            </Box>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AppDownload;
